<template lang="pug">
    article.contacts
        NextPageTrigger(v-observe-visibility='e => {reachStartTrigger = e}', :triggerstart='reachStartTrigger', url='/career')
        BlockVisibilityTrigger(:theme='"black"')
        //-
            .contacts__main
                .contacts__wrap
                    .h1.h1--color-main.contacts__title(v-html='contacts.title')

        .contacts__map(ref='map')
            //- iframe.contacts__iframe(
            //-     width='600',
            //-     height='500',
            //-     frameborder='0',
            //-     style='border:0',
            //-     src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2248.4471710605585!2d37.62207701639732!3d55.69859858053897!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46b54b5046fac75d%3A0xb983bde44fb10a44!2z0JLQsNGA0YjQsNCy0YHQutC-0LUg0YguLCA5INGB0YLRgNC-0LXQvdC40LUgMSwg0JzQvtGB0LrQstCwLCAxMTcxMDU!5e0!3m2!1sru!2sru!4v1564736547856!5m2!1sru!2sru'
            //-     allowfullscreen)
            .contacts__iframe
                .iframe__pointer
                    .icon
            .contacts__info
                .contacts__text.contacts__text--bold(v-html='contacts.map.address')
                .contacts__text(v-html='contacts.map.name')
                .contacts__text(v-html='contacts.map.phone')
        .contacts__routes
            .contacts__card(v-for='item in contacts.map.routs', v-observe-visibility='visibilityChanged')
                .contacts__label(v-html='item.type')
                .contacts__text(v-html='item.description')

        .contacts__emails.contacts__last-block(v-observe-visibility='visibilityChanged')
            .h1.h1--color-main.contacts__subtitle(v-html='contacts.emails.title')
            .contacts__wrap
                a.contacts__email-wrap(v-for='item in contacts.emails.list', :href='"mailto:" + item.email')
                    .contacts__name(v-html='item.name')
                    .contacts__email(v-html='item.email')

        //- .contacts__form(v-observe-visibility='visibilityChanged')
        //-     Form(type='feedback')

        Footer

</template>

<script>
// import Form from '../components/FormContacts.vue';
import Footer from '../components/Footer.vue';
import NextPageTrigger from '../components/NextPageTrigger.vue';
import BlockVisibilityTrigger from '../components/BlockVisibilityTrigger.vue';
import IconPointer from '../assets/img/pointer.svg';

import contactsData from '../assets/data/contacts.json';
import isMobileVP from '../assets/js/isMobileVP.js';

export default {
    name: 'contacts',

    components: {
        // Form,
        Footer,
        NextPageTrigger,
        BlockVisibilityTrigger,
        IconPointer
    },

    data() {
        return {
            contacts: contactsData,
            reachStartTrigger: false
        };
    },

    computed: {},

    beforeMount() {},

    beforeDestroy() {},

    methods: {
        isMobileVP() {
            return isMobileVP();
        },
        visibilityChanged(e, el) {
            if (e) {
                el.target.classList.add('show');
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import '../assets/css/vars.scss';
@import '../assets/css/base.scss';
@import '../assets/css/animations.scss';

:root {
    --vh: 5.68px;
}

.contacts {
    padding-top: 2.8em;
    background-color: var(--color-main-bg);

    @media (--viewport-tablet) {
        padding-top: 2.8em;
    }

    &__title,
    &__subtitle {
        width: calc(var(--layout-column-width) * 6 + var(--layout-gutter-width) * 5);
        margin: 0 auto;
        text-align: center;
        margin-bottom: 3.2em;

        @media (--viewport-tablet) {
            width: calc(var(--layout-column-width) * 10 + var(--layout-gutter-width) * 9);
            margin-bottom: 1.15em;
            text-align: left;
        }
    }

    &__subtitle {
        margin-bottom: 1.46em;

        @media (--viewport-tablet) {
            margin-bottom: 0.8em;
        }
    }

    &__wrap {
        width: calc(var(--layout-column-width) * 6 + var(--layout-gutter-width) * 5);
        margin: 0 auto;
        display: flex;
        flex-wrap: wrap;

        @media (--viewport-tablet) {
            width: calc(var(--layout-column-width) * 10 + var(--layout-gutter-width) * 9);
        }
    }

    &__email-wrap {
        width: 50%;
        margin-bottom: 1em;
        color: var(--color-main-text);
        opacity: 0.8;
        text-decoration: none;

        &:hover,
        &:focus {
            opacity: 1;
        }

        @media (--viewport-tablet) {
            width: 100%;
        }
    }

    &__name {
        font-family: var(--font-accent);
    }

    &__map {
        position: relative;
        margin-bottom: 8em;
    }

    &__iframe {
        position: relative;
        width: 100%;
        height: 550px;
        background-image: url('../assets/img/contacts/map2.png');
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center center;

        .iframe__pointer {
            position: absolute;
            top: calc(550px - 310px - (305px * 0.5));
            left: 50%;
            transform: translateX(-40%);
            width: 305px;
            height: 305px;
            z-index: 100;

            .icon {
                width: 100%;
                height: 100%;
                background-image: url('../assets/img/pointer.svg');
                background-repeat: no-repeat;
                background-size: cover;
                background-position: center center;
            }
        }
    }

    &__info {
        position: absolute;
        top: 28%;
        left: calc(var(--layout-column-width) + var(--layout-gutter-width));
        // height: 80%;
        width: calc(var(--layout-column-width) * 3.5 + var(--layout-gutter-width) * 3);
        background-color: var(--color-main-bg);
        padding: 2em;

        @media (--viewport-tablet) {
            position: relative;
            top: 0;
            left: 0;
            height: auto;
            width: calc(var(--layout-column-width) * 10 + var(--layout-gutter-width) * 9);
            padding: 0;
            margin: 0 auto;
            margin-top: 10vh;
        }
    }

    &__text {
        margin-bottom: 2em;

        &:last-of-type {
            margin-bottom: 0;
        }

        p {
            margin-bottom: 1em;
        }

        &--bold {
            font-family: var(--font-accent);
        }
    }

    &__routes {
        display: flex;
        flex-wrap: wrap;
        width: calc(var(--layout-column-width) * 6 + var(--layout-gutter-width) * 5);
        margin: 0 auto 2em;

        @media (--viewport-tablet) {
            width: calc(var(--layout-column-width) * 10 + var(--layout-gutter-width) * 9);
        }
    }

    &__card {
        margin-bottom: 2em;
        width: 45%;
        margin-right: var(--layout-gutter-width);
        opacity: 0;
        transform: translateY(50px);

        &.show {
            opacity: 1;
            transform: translateY(0px);
            transition: opacity 1s ease 0.2s, transform 1s cubic-bezier(0.39, 0.575, 0.565, 1) 0.2s;
        }

        &:nth-child(2n) {
            margin-right: 0;
        }

        @media (--viewport-tablet) {
            width: 100%;
            margin-right: 0;
        }
    }

    &__emails,
    &__form {
        padding-bottom: 4em;
        opacity: 0;
        transform: translateY(50px);

        &.show {
            opacity: 1;
            transform: translateY(0px);
            transition: opacity 1s ease 0.2s, transform 1s cubic-bezier(0.39, 0.575, 0.565, 1) 0.2s;
        }
    }

    &__last-block {
        margin-bottom: 3.6em;
    }

    &__label {
        position: relative;
        display: block;
        font-size: 1.4em;
        font-weight: 500;
        line-height: 1.2;
        text-transform: uppercase;
        margin-bottom: 1em;

        &:after {
            content: '';
            position: relative;
            display: block;
            height: 4px;
            width: 100%;
            background-color: currentColor;
            top: 0.25em;
        }

        &:before {
            content: '';
            position: absolute;
            top: -1em;
            right: -1.5em;
            display: inline-block;
            width: 3em;
            height: 3em;
            border-radius: 100%;
            background-color: var(--color-main-text);
            opacity: 0.3;
            animation: shake-slow 110s -1.3s cubic-bezier(0.445, 0.05, 0.55, 0.95) infinite;
        }

        .contacts__card:nth-child(1) & {
            &:before {
                top: -1.5em;
                left: 3em;
                width: 2em;
                height: 2em;
                animation: shake-slow 80s -1.3s cubic-bezier(0.445, 0.05, 0.55, 0.95) infinite;
            }
        }

        .contacts__card:nth-child(2) & {
            &:before {
                top: -0.7em;
                left: 2em;
                width: 3em;
                height: 3em;
                animation: shake-slow 100s -2.3s cubic-bezier(0.445, 0.05, 0.55, 0.95) infinite;
            }
        }

        .contacts__card:nth-child(3) & {
            &:before {
                top: -0.6em;
                left: 5.7em;
                width: 2em;
                height: 2em;
                animation: shake-slow 140s -4.3s cubic-bezier(0.445, 0.05, 0.55, 0.95) infinite;
            }
        }

        .contacts__card:nth-child(4) & {
            &:before {
                top: -1.8em;
                left: 0.9em;
                width: 2.5em;
                height: 2.5em;
                animation: shake-slow 110s -1.3s cubic-bezier(0.445, 0.05, 0.55, 0.95) infinite;
            }
        }
    }
}
</style>
